import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axiosProtected from "../config/baseWithToken";
import { useEffect } from "react";

export const addShipping = createAsyncThunk(
  "admin/shipping/add",
  async (shippingInfo, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.post(`/admin/shipping`, shippingInfo);
      toast.success(data.message);
      dispatch(getShippingList());
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const updateShipping = createAsyncThunk(
  "admin/shipping/update",
  async (shippingInfo, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/shipping/${shippingInfo.shippingId}`,
        shippingInfo.updateDetails
      );
      toast.success(data.message);
      dispatch(getShippingList());
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const deleteCarrier = createAsyncThunk(
  "admin/shipping/delete/carrier",
  async (shippingInfo, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/shipping/${shippingInfo?.shippingId}/carrier/${shippingInfo?.carrierId}`
      );
      toast.success(data.message);
      dispatch(getShippingList());
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const deleteShipping = createAsyncThunk(
  "admin/shipping/delete/shipping",
  async (shippingId, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/shipping/delete/${shippingId}`
      );
      toast.success(data.message);
      dispatch(getShippingList());
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);
export const getShippingList = createAsyncThunk(
  "admin/shipping",
  async (thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(`/admin/shipping`);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
